<template>
  <div class="character-video-wrapper">
    <video-layout
      nav-title="单字详情"
      :item="item"
      :back="back"
    >
      <backdrop-video
        :item="item"
      />
      <basis-locked
        v-if="item.locked"
        support-vip
        support-credits
        :item="item"
        :locked-data="course"
        @clickHandler="clickHandler"
      />
    </video-layout>
    <div class="popup-wrapper">
      <!-- 积分支付 -->
      <basis-credits-popup
        v-model="showCredits"
        :credits-needed="course.creditsNeeded"
        @pay="payHandler"
      />
    </div>
  </div>
</template>

<script>
import { BasisLocked, BasisCreditsPopup } from '@/components/basis'
import BackdropVideo from './components/BackdropVideo'
import VideoLayout from './components/VideoLayout'
import { mapGetters, mapActions } from 'vuex'
import { Character } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'CharacterVideo',
  components: { BasisLocked, BasisCreditsPopup, BackdropVideo, VideoLayout },
  mixins: [mixinWxShare],
  data: () => ({
    characterId: null,
    item: {
      locked: false
    },
    payType: '',
    showCredits: false,
    payLoading: false,
    isPaySuccess: false
  }),
  computed: {
    ...mapGetters(['course', 'credits'])
  },
  watch: {
    '$route.params.id': {
      handler (newId, oldId) {
        if (newId !== oldId) {
          this.getCharacter()
        }
      }
    }
  },
  mounted () {
    this.getCharacter()
  },
  methods: {
    ...mapActions(['updateVip']),
    back () {
      const { teacherId, courseId } = this.$route.params
      this.$router.push({
        name: 'course-id',
        params: {
          id: courseId,
          teacherId
        }
      })
    },
    async getCharacter () {
      try {
        const { id } = this.$route.params
        this.characterId = id
        const { character: item } = await Character.detail({ id })
        this.item = item
      } catch (error) {
        console.log(error)
      }
    },
    clickHandler (type) {
      this.payType = type
      switch (type) {
        case 'credits':
          this.showCredits = true
          break
        case 'vip':
          // 前往 VIP 充值 Locked 组件中包含该功能
          break
      }
    },
    async payHandler (callback) {
      try {
        const { order: { character: item }} = await Character.unlock({
          id: this.characterId,
          payType: this.payType
        })
        this.$notify({ type: 'success', message: '解锁成功' })
        this.item = item
        this.showCredits = false
        this.isPaySuccess = true
        callback()
      } catch (error) {
        callback()
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.character-video-wrapper {
  .popup-wrapper {
    .pay-by-credits-wrapper {
      padding: 16px;
      .title {
        position: relative;
        padding-bottom: 16px;
        .label-title {
          @include sc($font-size-base, $color-text-light);
          @include lw(17px, 500);
        }
        .credits-count {
          @include sc($font-size-md, #F24724);
          @include lw(14px);
          padding-top: 8px;
        }
        .create-vip-text {
          @include sc($font-size-base, #FFA119);
          position: absolute;
          top: 12px;
          right: 0;
          .van-icon {
            vertical-align: middle;
          }
        }
      }
      .pay-button-wrapper {
        .credits-button {
          font-size: $font-size-lg;
          @include lg-radius(#ECCEA2, #E7B170, 4px);
          @include normal-button(100%, 39px);
        }
      }
    }
  }
}
</style>
